import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              P站视频全攻略
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              致力于提供最全面、最实用的P站视频使用教程，帮助用户掌握搜索、浏览、下载、收藏等核心技能。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              教程分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 3).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(3).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  首页
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 P站视频全攻略. 本站为教程指南类网站，仅供学习参考。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="/"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors"
            >
              隐私政策
            </a>
            <a
              href="/"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}